import { Breadcrumbs } from 'V2Components'
import { getHTMLDataTestID } from 'infra/utils'
import { Typography } from 'procyon-ui'
import React from 'react'

function SummaryHeader({ breadCrumbsItems = [], rsrcName = '', actions, Icon = null }) {
  return (
    <div className='-ml-5 -mr-5 -mt-6 p-4 pb-6'>
      <Breadcrumbs maxItems={5} breadCrumbs={breadCrumbsItems} />
      <div className='flex justify-between items-center mt-4'>
        <Typography
          data-testid={getHTMLDataTestID('summary-header', 'p', 'header')}
          className='flex items-center gap-2'
          variant='h2'
        >
          {Icon && <Icon className='!rounded w-7 h-7' />}
          {rsrcName}
        </Typography>
        <div
          data-testid={getHTMLDataTestID('summary-header', 'div', 'actions')}
          className='flex gap-4'
        >
          {actions && actions}
        </div>
      </div>
    </div>
  )
}

export { SummaryHeader }
